/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Auction, AuctionInterface } from "../Auction";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "ptgId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [],
    name: "AuctionCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minBidAmount",
        type: "uint256",
      },
    ],
    name: "NewAuction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "highestBidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "highestBid",
        type: "uint256",
      },
    ],
    name: "NewBid",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "auctions",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minBidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minIncrement",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "canceled",
        type: "bool",
      },
      {
        internalType: "address",
        name: "highestBidder",
        type: "address",
      },
      {
        internalType: "bool",
        name: "ownerHasWithdrawn",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "highestBidderHasWithdrawn",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "cancelAuction",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "claimItem",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "claimPayment",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "getAuctionBidders",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "bidder",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "time",
            type: "uint256",
          },
        ],
        internalType: "struct IAuction.Bid[]",
        name: "bidders",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "bidderAddress",
        type: "address",
      },
    ],
    name: "getBidAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "highestBidAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenIds",
    outputs: [
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "auctionId",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60c060405234801561001057600080fd5b506040516200161a3803806200161a833981016040819052610031916100f0565b6100416301ffc9a760e01b61006c565b610051630271189760e51b61006c565b60609190911b6001600160601b03191660805260a052610128565b6001600160e01b031980821614156100cb576040805162461bcd60e51b815260206004820152601c60248201527f4552433136353a20696e76616c696420696e7465726661636520696400000000604482015290519081900360640190fd5b6001600160e01b0319166000908152602081905260409020805460ff19166001179055565b60008060408385031215610102578182fd5b82516001600160a01b0381168114610118578283fd5b6020939093015192949293505050565b60805160601c60a0516114bc6200015e6000398061053752806106405280610785525080610601528061080252506114bc6000f3fe608060405234801561001057600080fd5b50600436106100a45760003560e01c806301ffc9a7146100a9578063571a26a0146100d2578063714cff56146100fc5780637da393e01461011157806396b5a75514610124578063b47089b414610137578063bc197c811461014a578063c63fdcc71461016a578063df2764691461017d578063f23a6e611461019d578063f3fef3a3146101b0578063f669db83146101c3575b600080fd5b6100bc6100b7366004610e4a565b6101d6565b6040516100c99190610f87565b60405180910390f35b6100e56100e0366004610e79565b6101f9565b6040516100c99b9a99989796959493929190611418565b610104610265565b6040516100c991906113f0565b6100bc61011f366004610e79565b61026b565b6100bc610132366004610e79565b610391565b610104610145366004610e91565b610455565b61015d610158366004610d13565b610481565b6040516100c99190610f92565b6100bc610178366004610e79565b61049b565b61019061018b366004610e79565b61055c565b6040516100c99190610f25565b61015d6101ab366004610dbe565b6105f4565b6100bc6101be366004610e21565b6106b3565b6101046101d1366004610e79565b6107b6565b6001600160e01b0319811660009081526020819052604090205460ff165b919050565b6001602081905260009182526040909120805491810154600282015460038301546004840154600585015460068601546007870154600a909701546001600160a01b03968716979596949593949293919260ff808416936101009081900490921692808216929004168b565b60025481565b6000818152600160205260408120600a810154610100900460ff16156102ac5760405162461bcd60e51b81526004016102a390611143565b60405180910390fd5b600781015460ff16806102c25750806004015442115b6102de5760405162461bcd60e51b81526004016102a39061103b565b600781015460ff168061030f575080600401544211801561030f5750600781015461010090046001600160a01b0316155b1561035057600a8101805461ff0019166101001790556001818101546002830154610345926001600160a01b03909216916107e8565b5060019150506101f4565b600a8101805461010061ff0019909116811790915560078201546002830154610387929091046001600160a01b03169060016107e8565b5060019392505050565b60008181526001602081905260408220908101546001600160a01b031633146103cc5760405162461bcd60e51b81526004016102a39061120f565b806003015442106103ef5760405162461bcd60e51b81526004016102a39061118f565b600781015460ff16156104145760405162461bcd60e51b81526004016102a390611304565b60078101805460ff191660011790556040517fa5fb31e47bd1eca58bf14a3312d5e6aeafdc4ee787c8ed348c15c2b092324d9390600090a150600192915050565b60008281526001602090815260408083206001600160a01b038516845260090190915290205492915050565b600060405162461bcd60e51b81526004016102a3906113ac565b6000818152600160205260408120600481015442116104cc5760405162461bcd60e51b81526004016102a39061127a565b600a81015460ff16156104f15760405162461bcd60e51b81526004016102a390611143565b600a8101805460ff19166001908117909155810154600782015461010090046001600160a01b0390811660009081526009840160205260409020546103879291909116907f0000000000000000000000000000000000000000000000000000000000000000906107e8565b606060016000838152602001908152602001600020600801805480602002602001604051908101604052809291908181526020016000905b828210156105e9576000848152602090819020604080516060810182526003860290920180546001600160a01b0316835260018082015484860152600290910154918301919091529083529092019101610594565b505050509050919050565b6000336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461063e5760405162461bcd60e51b81526004016102a39061109d565b7f00000000000000000000000000000000000000000000000000000000000000008514156106775761067286858585610879565b6106a0565b6106848686868686610adf565b6106a05760405162461bcd60e51b81526004016102a3906111ef565b5063f23a6e6160e01b9695505050505050565b600081815260016020526040812060078101546001600160a01b038581166101009092041614156106f65760405162461bcd60e51b81526004016102a3906111b8565b6001600160a01b0384163314806107105750806004015442115b61072c5760405162461bcd60e51b81526004016102a390611355565b6001600160a01b0384166000908152600982016020526040902054806107645760405162461bcd60e51b81526004016102a39061116e565b6001600160a01b03851660009081526009830160205260408120556107aa857f0000000000000000000000000000000000000000000000000000000000000000836107e8565b50600195945050505050565b6000908152600160209081526040808320600781015461010090046001600160a01b0316845260090190915290205490565b604051637921219560e11b81526000906001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063f242432a9061083d903090889088908890600401610eed565b600060405180830381600087803b15801561085757600080fd5b505af115801561086b573d6000803e3d6000fd5b506001979650505050505050565b826108965760405162461bcd60e51b81526004016102a39061111d565b60006108a482840184610e79565b600081815260016020819052604090912090810154919250906001600160a01b03878116911614156108e85760405162461bcd60e51b81526004016102a39061106d565b600781015460ff161561090d5760405162461bcd60e51b81526004016102a3906112bc565b806004015442106109305760405162461bcd60e51b81526004016102a39061132e565b806003015442116109535760405162461bcd60e51b81526004016102a3906112df565b6001600160a01b038087166000908152600983016020526040808220546007850154610100900490931682529020546005830154918701918210156109aa5760405162461bcd60e51b81526004016102a390611004565b826006015481018210156109d05760405162461bcd60e51b81526004016102a390611232565b6001600160a01b038881166000818152600986016020908152604080832087905580516060810182528481528083018881524292820192835260088a01805460018082018355918752949095209151600390940290910180546001600160a01b031916938716939093178355519282019290925590516002909101556007850154610100900490911614610a8157600783018054610100600160a81b0319166101006001600160a01b038b16021790555b825460078401546040516001600160a01b03808c16927f775c0076f1a3eda8416a89428d5a3592db650e40f872b9ca96f21d212b23e34c92610acd9288926101009004169087906113f9565b60405180910390a35050505050505050565b600083600114610b015760405162461bcd60e51b81526004016102a390610fa7565b6000808080610b1286880188610ebc565b9350935093509350610b288a85858c8686610b39565b5060019a9950505050505050505050565b60006001600160a01b038716610b615760405162461bcd60e51b81526004016102a3906110ed565b610b6b6002610c1b565b6000610b776002610c24565b60008181526001602081905260409182902083815590810180546001600160a01b0319166001600160a01b038d16908117909155600382018b9055600482018a905560028201899055600582018890556006820187905591519293509188918a917f126eb1ad4af9a190099312f3eef9d9cf237204a4cab3d989b2446bc6463848b590610c079087908b90611478565b60405180910390a450979650505050505050565b80546001019055565b5490565b80356001600160a01b03811681146101f457600080fd5b600082601f830112610c4f578081fd5b81356001600160401b0380821115610c6357fe5b602080830260405182828201018181108582111715610c7e57fe5b604052848152945081850192508582018187018301881015610c9f57600080fd5b600091505b84821015610cc2578035845292820192600191909101908201610ca4565b505050505092915050565b60008083601f840112610cde578081fd5b5081356001600160401b03811115610cf4578182fd5b602083019150836020828501011115610d0c57600080fd5b9250929050565b60008060008060008060a08789031215610d2b578182fd5b610d3487610c28565b9550610d4260208801610c28565b945060408701356001600160401b0380821115610d5d578384fd5b610d698a838b01610c3f565b95506060890135915080821115610d7e578384fd5b610d8a8a838b01610c3f565b94506080890135915080821115610d9f578384fd5b50610dac89828a01610ccd565b979a9699509497509295939492505050565b60008060008060008060a08789031215610dd6578182fd5b610ddf87610c28565b9550610ded60208801610c28565b9450604087013593506060870135925060808701356001600160401b03811115610e15578283fd5b610dac89828a01610ccd565b60008060408385031215610e33578182fd5b610e3c83610c28565b946020939093013593505050565b600060208284031215610e5b578081fd5b81356001600160e01b031981168114610e72578182fd5b9392505050565b600060208284031215610e8a578081fd5b5035919050565b60008060408385031215610ea3578182fd5b82359150610eb360208401610c28565b90509250929050565b60008060008060808587031215610ed1578384fd5b5050823594602084013594506040840135936060013592509050565b6001600160a01b0394851681529290931660208301526040820152606081019190915260a06080820181905260009082015260c00190565b602080825282518282018190526000919060409081850190868401855b82811015610f7a57815180516001600160a01b0316855286810151878601528501518585015260609093019290850190600101610f42565b5091979650505050505050565b901515815260200190565b6001600160e01b031991909116815260200190565b6020808252603d908201527f41756374696f6e236f6e4552433131353552656365697665643a206d6179206f60408201527f6e6c7920616464206f6e652061756374696f6e20617420612074696d65000000606082015260800190565b6020808252601f908201527f43616e6e6f74206269642062656c6f77206d696e696d756d20616d6f756e7400604082015260600190565b6020808252601890820152771b5d5cdd081899481bdd995c881bdc8818d85b98d95b195960421b604082015260600190565b60208082526016908201527513dddb995c8818d85b9b9bdd081c1b1858d948189a5960521b604082015260600190565b60208082526030908201527f41756374696f6e236f6e4552433131353552656365697665643a20696e76616c60408201526f6964206173736574206164647265737360801b606082015260800190565b60208082526016908201527513dddb995c881b5d5cdd081899481cdc1958da59995960521b604082015260600190565b6020808252600c908201526b043616e6e6f742062696420360a41b604082015260600190565b60208082526011908201527030b63932b0b23c903bb4ba34323930bbb760791b604082015260600190565b6020808252600790820152666e6f206269647360c81b604082015260600190565b6020808252600f908201526e185b1c9958591e481cdd185c9d1959608a1b604082015260600190565b6020808252601f908201527f6869676865737420626964646572206d6179206e6f7420776974686472617700604082015260600190565b60208082526006908201526519985a5b195960d21b604082015260600190565b6020808252600990820152682737ba1037bbb732b960b91b604082015260600190565b60208082526028908201527f4e657720626964206973206c657373207468616e206d696e696d756d206869676040820152671a195cdd08189a5960c21b606082015260800190565b60208082526022908201527f43616e2774207769746864726177206265666f72652061756374696f6e20656e604082015261647360f01b606082015260800190565b60208082526009908201526818d85b98d95b1b195960ba1b604082015260600190565b6020808252600b908201526a1b9bdd081cdd185c9d195960aa1b604082015260600190565b60208082526010908201526f185b1c9958591e4818d85b98d95b195960821b604082015260600190565b6020808252600d908201526c185b1c9958591e48195b991959609a1b604082015260600190565b60208082526037908201527f6f6e6c7920746865206269646465722063616e2077697468647261772062656660408201527637b932903a34329030bab1ba34b7b71034b99037bb32b960491b606082015260800190565b60208082526024908201527f62617463682061756374696f6e206372656174696f6e206e6f7420737570706f6040820152631c9d195960e21b606082015260800190565b90815260200190565b9283526001600160a01b03919091166020830152604082015260600190565b9a8b526001600160a01b03998a1660208c015260408b019890985260608a0196909652608089019490945260a088019290925260c0870152151560e086015290921661010084015290151561012083015215156101408201526101600190565b91825260208201526040019056fea2646970667358221220e8ee754dfaf4ee9a0b93ceb8f063e1aee7303e7580589896bc33f1332a56930e64736f6c63430007040033";

export class Auction__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsContract: string,
    ptgId: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Auction> {
    return super.deploy(
      assetsContract,
      ptgId,
      overrides || {}
    ) as Promise<Auction>;
  }
  getDeployTransaction(
    assetsContract: string,
    ptgId: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsContract, ptgId, overrides || {});
  }
  attach(address: string): Auction {
    return super.attach(address) as Auction;
  }
  connect(signer: Signer): Auction__factory {
    return super.connect(signer) as Auction__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AuctionInterface {
    return new utils.Interface(_abi) as AuctionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Auction {
    return new Contract(address, _abi, signerOrProvider) as Auction;
  }
}
